import { Box, DialogContent, Grid, Switch } from '@mui/material';
import { styled } from '@mui/material/styles';
import { isEmpty } from 'lodash-es';
import { FC, useState } from 'react';
import { IKibanaAnalyticsSettingsPayload } from 'wisestep-api';
import { WsDialog, Label, WsColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import { warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { HeaderBox } from '../components/HeaderBox';
export interface ModifySettingsDialogProps {
  openDialog: boolean;
  closeDialog(): void;
  handler: (payload) => void;
  data;
}
const BoldLabel = styled(Label)(() => ({
  fontWeight: 'bold',
}));
const ModifySettingsDialog: FC<ModifySettingsDialogProps> = ({
  openDialog,
  closeDialog,
  handler,
  data,
}) => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const roles = ['User', 'Lead', 'Account Manager', 'Analyst', 'Head'];
  const [payload, setPayload] = useState<IKibanaAnalyticsSettingsPayload>();
  const changeRoles = (label) => {
    const tempData = data;
    const idx = tempData?.roles?.indexOf(label);
    if (idx != null) {
      if (idx === -1) {
        tempData?.roles?.push(label);
      } else {
        tempData?.roles?.splice(idx, 1);
      }
      setPayload({ ...tempData });
    }
  };
  return (
    <Box component="form">
      <WsDialog openDialog={openDialog}>
        <DialogContent>
          <HeaderBox
            title={'Customize Analytics For Your Workspace'}
            includeBtn={true}
            onClick={() => {
              if (payload && !isEmpty(payload?.roles)) {
                payload ? handler(payload) : handler(data);
                closeDialog();
              } else {
                setNotification(warning('Please select atleast ONE ROLE'));
              }
            }}
          />

          <Box display="flex" flexDirection="column" width="100%">
            <Grid
              container
              mb={3}
              item
              display="flex"
              justifyContent="flex-start"
              alignItems="center"
            >
              <BoldLabel sx={{ marginRight: 8 }}>{data?.name}</BoldLabel>
              <WsTypography variant={WsTypoVariants.BODY1}>{data?.label}</WsTypography>
            </Grid>

            <Grid container xs={12} item mb={2}>
              <BoldLabel>Select the roles, who can view the Analytics</BoldLabel>
            </Grid>
            <Grid container xs={12} gap={2}>
              {roles.map((label) => (
                <Grid
                  item
                  xs={5}
                  display="flex"
                  justifyContent="space-between"
                  border="solid"
                  key={label}
                  borderColor={WsColors.BorderGrey}
                  borderRadius={1}
                  sx={{ borderWidth: 2.5 }}
                  alignItems="center"
                  p={1}
                >
                  <BoldLabel>{label}</BoldLabel>
                  <Switch
                    name={label}
                    checked={data?.roles?.indexOf(label) != -1}
                    value={label}
                    onChange={() => changeRoles(label)}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        </DialogContent>
      </WsDialog>
    </Box>
  );
};
export default ModifySettingsDialog;
